<template>
    <el-dialog title="关于我们" :visible.sync="centerDialogVisible" width="800px" :close-on-click-modal="false" class="aboutUs">
        <UEditor :content="shopdesp" ref="uEditor" @getUEditorContent="getTrySeeContent"></UEditor>
        <div class="btnBox">
            <el-button class="cancel" @click="close">取 消</el-button>
            <el-button type="primary" @click="comfirm">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import UEditor from 'base/uEditor/uEditor2'
import {uploadShopDesp} from 'api/accountApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    data() {
        return {
            centerDialogVisible: false,
            shopdesp: ''
        }
    },
    props: ['data'],
    methods: {
        open() {
            this.centerDialogVisible = true
            this.shopdesp = this.data.shopdesp
            this.$nextTick(() => {
                this.$refs.uEditor.init(this.shopdesp)
            })
            if (this.$refs.uEditor) {
            }
        },
        close() {
            this.centerDialogVisible = false
        },
        comfirm() {
            if (this.shopdesp) {
                this.setLoading(true)
                let options = {
                    shopdesp: this.shopdesp
                }
                uploadShopDesp({
                    data: options,
                    success: res => {
                        this.setLoading(false)
                        this.close()
                        this.$message.success('设置成功')
                        this.$emit('setAboutUs', this.shopdesp)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            } else {
                this.$message.error('请输入关于我们')
            }
        },
        getTrySeeContent(content) {
            this.shopdesp = content
            console.log(content)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        UEditor
    },
    watch: {
        'data': {
            handler(newV) {
                console.log(newV.shopdesp)
                if (newV) {
                    this.shopdesp = newV.shopdesp
                    
                }
            },
            deep: true
        },
    }
}
</script>
<style lang="scss">
    .el-popup-parent--hidden>.edui-default {
        z-index: 10000 !important;
    }
    // .edui-popup {
    //     z-index: 10000 !important;
    //     .edui-default {
    //         z-index: 10000 !important;
    //     }
    // }
    .aboutUs {
        .uEditor {
            .content {
                &>div {
                    width: 760px;
                    .edui-editor {
                        width: 760px !important;
                        .edui-editor-iframeholder {
                            width: 760px !important;
                            height: 275px !important;
                        }
                    }
                }
            }
        }
        .btnBox {
            display: flex;
            padding: 30px 0 0;
            justify-content: center;
            align-items: center;
            .cancel {
                margin-right: 20px;

            }
        }
    }
</style>